// GENERATED FILE, PLEASE DO NOT EDIT
var SystemCaviarBlack = '#101216';
var SystemCaviarGrey100 = '#FAFAFA';
var SystemCaviarGrey200 = '#EFF1F3';
var SystemCaviarGrey300 = '#CCD1D5';
var SystemCaviarGrey400 = '#6E767E';
var SystemCaviarGrey500 = '#4B5862';
var SystemCaviarGrey600 = '#2D3C48';
var SystemCaviarGrey700 = '#26333D';
var SystemCaviarGrey800 = '#1F2327';
var SystemCaviarRed100 = '#FFCCCC';
var SystemCaviarRed200 = '#D92B2B';
var SystemCaviarRed300 = '#C22626';
var SystemCaviarRed400 = '#AD2222';
var SystemCaviarRed500 = '#981E1E';
var SystemCaviarRed600 = '#821A1A';
var SystemCaviarRed700 = '#6D1616';
var SystemCaviarRed800 = '#571111';
var SystemCaviarYellow100 = '#FFF0C2';
var SystemCaviarYellow200 = '#FFCC33';
var SystemCaviarYellow300 = '#E5B82E';
var SystemCaviarYellow400 = '#CCA329';
var SystemCaviarYellow500 = '#B38F24';
var SystemCaviarYellow600 = '#997A1F';
var SystemCaviarYellow700 = '#80661A';
var SystemCaviarYellow800 = '#665214';
var SystemCaviarGreen100 = '#DFEFD9';
var SystemCaviarGreen200 = '#24B324';
var SystemCaviarGreen300 = '#20A120';
var SystemCaviarGreen400 = '#1D8F1D';
var SystemCaviarGreen500 = '#197D19';
var SystemCaviarGreen600 = '#166B16';
var SystemCaviarGreen700 = '#125912';
var SystemCaviarGreen800 = '#0E480E';
var SystemCaviarOrange100 = '#FDC7B3';
var SystemCaviarOrange200 = '#F86932';
var SystemCaviarOrange300 = '#DF5F2D';
var SystemCaviarOrange400 = '#C65428';
var SystemCaviarOrange500 = '#AE4A23';
var SystemCaviarOrange600 = '#953F1E';
var SystemCaviarOrange700 = '#7C3419';
var SystemCaviarOrange800 = '#632A14';
var SystemCaviarBlue100 = '#DEF1FA';
var SystemCaviarBlue200 = '#00ACED';
var SystemCaviarBlue300 = '#009AD4';
var SystemCaviarBlue400 = '#0089BD';
var SystemCaviarBlue500 = '#0078A6';
var SystemCaviarBlue600 = '#00678E';
var SystemCaviarBlue700 = '#005677';
var SystemCaviarBlue800 = '#00455F';
var SystemCaviarBlackPure = '#000000';
var ColorTokensAll = {
  SystemCaviarBlack: SystemCaviarBlack,
  SystemCaviarBlackPure: SystemCaviarBlackPure,
  SystemCaviarBlue100: SystemCaviarBlue100,
  SystemCaviarBlue200: SystemCaviarBlue200,
  SystemCaviarBlue300: SystemCaviarBlue300,
  SystemCaviarBlue400: SystemCaviarBlue400,
  SystemCaviarBlue500: SystemCaviarBlue500,
  SystemCaviarBlue600: SystemCaviarBlue600,
  SystemCaviarBlue700: SystemCaviarBlue700,
  SystemCaviarBlue800: SystemCaviarBlue800,
  SystemCaviarGreen100: SystemCaviarGreen100,
  SystemCaviarGreen200: SystemCaviarGreen200,
  SystemCaviarGreen300: SystemCaviarGreen300,
  SystemCaviarGreen400: SystemCaviarGreen400,
  SystemCaviarGreen500: SystemCaviarGreen500,
  SystemCaviarGreen600: SystemCaviarGreen600,
  SystemCaviarGreen700: SystemCaviarGreen700,
  SystemCaviarGreen800: SystemCaviarGreen800,
  SystemCaviarGrey100: SystemCaviarGrey100,
  SystemCaviarGrey200: SystemCaviarGrey200,
  SystemCaviarGrey300: SystemCaviarGrey300,
  SystemCaviarGrey400: SystemCaviarGrey400,
  SystemCaviarGrey500: SystemCaviarGrey500,
  SystemCaviarGrey600: SystemCaviarGrey600,
  SystemCaviarGrey700: SystemCaviarGrey700,
  SystemCaviarGrey800: SystemCaviarGrey800,
  SystemCaviarOrange100: SystemCaviarOrange100,
  SystemCaviarOrange200: SystemCaviarOrange200,
  SystemCaviarOrange300: SystemCaviarOrange300,
  SystemCaviarOrange400: SystemCaviarOrange400,
  SystemCaviarOrange500: SystemCaviarOrange500,
  SystemCaviarOrange600: SystemCaviarOrange600,
  SystemCaviarOrange700: SystemCaviarOrange700,
  SystemCaviarOrange800: SystemCaviarOrange800,
  SystemCaviarRed100: SystemCaviarRed100,
  SystemCaviarRed200: SystemCaviarRed200,
  SystemCaviarRed300: SystemCaviarRed300,
  SystemCaviarRed400: SystemCaviarRed400,
  SystemCaviarRed500: SystemCaviarRed500,
  SystemCaviarRed600: SystemCaviarRed600,
  SystemCaviarRed700: SystemCaviarRed700,
  SystemCaviarRed800: SystemCaviarRed800,
  SystemCaviarYellow100: SystemCaviarYellow100,
  SystemCaviarYellow200: SystemCaviarYellow200,
  SystemCaviarYellow300: SystemCaviarYellow300,
  SystemCaviarYellow400: SystemCaviarYellow400,
  SystemCaviarYellow500: SystemCaviarYellow500,
  SystemCaviarYellow600: SystemCaviarYellow600,
  SystemCaviarYellow700: SystemCaviarYellow700,
  SystemCaviarYellow800: SystemCaviarYellow800
};

export { ColorTokensAll, SystemCaviarBlack, SystemCaviarBlackPure, SystemCaviarBlue100, SystemCaviarBlue200, SystemCaviarBlue300, SystemCaviarBlue400, SystemCaviarBlue500, SystemCaviarBlue600, SystemCaviarBlue700, SystemCaviarBlue800, SystemCaviarGreen100, SystemCaviarGreen200, SystemCaviarGreen300, SystemCaviarGreen400, SystemCaviarGreen500, SystemCaviarGreen600, SystemCaviarGreen700, SystemCaviarGreen800, SystemCaviarGrey100, SystemCaviarGrey200, SystemCaviarGrey300, SystemCaviarGrey400, SystemCaviarGrey500, SystemCaviarGrey600, SystemCaviarGrey700, SystemCaviarGrey800, SystemCaviarOrange100, SystemCaviarOrange200, SystemCaviarOrange300, SystemCaviarOrange400, SystemCaviarOrange500, SystemCaviarOrange600, SystemCaviarOrange700, SystemCaviarOrange800, SystemCaviarRed100, SystemCaviarRed200, SystemCaviarRed300, SystemCaviarRed400, SystemCaviarRed500, SystemCaviarRed600, SystemCaviarRed700, SystemCaviarRed800, SystemCaviarYellow100, SystemCaviarYellow200, SystemCaviarYellow300, SystemCaviarYellow400, SystemCaviarYellow500, SystemCaviarYellow600, SystemCaviarYellow700, SystemCaviarYellow800, ColorTokensAll as default };
